import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { UploaderOptions, UploadFile } from '@usitsdasdesign/dds-ng/uploader';
import { of } from 'rxjs';

@Component({
  selector: 'app-custom-uploader',
  templateUrl: './custom-uploader.component.html',
  styleUrl: './custom-uploader.component.less',
})
export class CustomUploaderComponent {
  @Input() uploadAreaOptions: UploaderOptions = {};
  @Output() emitUploadedItems: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('selectFileBtn ') fileInputRef!: ElementRef<HTMLInputElement>;

  isDragging: boolean = false;

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = true;
  }

  onDragLeave(event: DragEvent): void {
    this.isDragging = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.isDragging = false;

    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const files = Array.from(event.dataTransfer.files);

      this.uploadedItems(files);
      event.dataTransfer.clearData();
    }
  }

  uploadedItems(files: File[]): void {
    const list: any[] =
      files?.map((file): any => ({
        isDownloadable: false,
        file: file,
        fileName: file.name,
        fileExtenstion: file.name.split('.').pop() || '', // Extract file extension
      })) ?? [];

    this.emitUploadedItems.emit(list);
  }

  onFileSelect(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.files && inputElement.files.length > 0) {
      const files = Array.from(inputElement.files);
      this.uploadedItems(files);
      this.fileInputRef.nativeElement.value = ''; // Resetting the selected file
    }
  }
}
